/**
 * For use to display cert on CM Conclusion page
 */

import React from 'react';
import PropTypes from 'prop-types';

import { DateTime } from 'luxon';

import certUtils from '../../../global/utils/certUtils';

const CertificateTemplatePreview = ({
  certificateTemplate
}) => {

  return (
    <div className="cert-wrapper">
      <div className="certificate -achieved">
        <div className="-cert-content">
          <div className="-cert-header">
            { certificateTemplate.partnerLogoUrl ? 
              <div className="-sponsor-info">
                <div className="-sponsor-logo">
                  <img src={certificateTemplate.partnerLogoUrl}/>
                </div>
              </div>
              :
              null 
            }
          </div>
          <div className="-cert-body">
            <h1 className="u-centerText">Certificate of Completion</h1>
            <div className="-certifies-that">{certificateTemplate.certifiesText ? certificateTemplate.certifiesText : 'This certifies that'}</div>
            <div className="-completor">[John Doe]</div>
            <div className="-has-successfully">{certificateTemplate.hasCompletedText ? certificateTemplate.hasCompletedText : 'has successfully completed'}</div>
            <div className="-tm-title">[Content Module Title]</div>
            <div className="-dates">
              <div className="-version">
                <strong>Version:</strong> [CM Version] 
              </div>
              <div className="-completion">
                <strong>Date of completion:</strong> [Aug 19, 2020] 
              </div>
              <div className="-expiration">
                <strong>Certificate expiration:</strong> [Aug 19, 2030]
              </div>
            </div>
            <div>
              <strong>Credits Earned:</strong> [1.0] {certificateTemplate.creditsEarnedSuffix ? certificateTemplate.creditsEarnedSuffix : '[CM CREDIT TYPE]'}
            </div>
          </div>
          <div className="-cert-sig">
            <div className="-signer-info">
              <div className="-signature">
                <img src={certificateTemplate.signerImageUrl}/>
              </div>
              <div className="-signer-name-position">
                {certificateTemplate.signerName} &mdash; {certificateTemplate.signerPosition}
              </div>
            </div>

          </div>
          <div className="-cert-footer">
            <div className="yt-row with-gutters space-between">
              <div className="yt-col _60">
                <div className="-accreditor-info">
                  <div className="-accreditor-logo">
                    <img alt="Accreditation body" src={certificateTemplate.accreditationLogoUrl}/>
                  </div>
                  <div className="-accreditor-description">
                    {certificateTemplate.accreditationDescription}
                  </div>
                </div>
              </div>
              <div className="yt-col _25">
                <div className="-sponsor-info">
                  <div className="-sponsor-logo">
                    { certificateTemplate.bottomRightStatus === 'overrideSponsorLogo' ? 
                      <img alt="Partner logo" src={certificateTemplate.bottomRightLogoUrl}/>
                      : certificateTemplate.bottomRightStatus === 'useSponsorLogo' ?
                      <em>[CM Sponsor Logo (if exists)]</em>
                      :
                      null 
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

CertificateTemplatePreview.propTypes = {
  certificateTemplate: PropTypes.object.isRequired 
}

export default CertificateTemplatePreview;



// WEBPACK FOOTER //
// modules/certificateTemplate/components/CertificateTemplatePreview.js.jsx